import { render, staticRenderFns } from "./Googleauth.vue?vue&type=template&id=2d79f479&"
import script from "./Googleauth.vue?vue&type=script&lang=js&"
export * from "./Googleauth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports